import { useState } from 'react';

export function useAnalyticsDrawer<T>() {
    const [analyticsDrawerRow, setAnalyticsDrawerRow] = useState<T | null>(null);

    return {
        analyticsDrawerRow,
        openAnalyticsDrawer: (row: T) => (event: React.KeyboardEvent | React.MouseEvent) => {
            if (
                event.type === 'keydown' &&
                ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')
            ) {
                return;
            }
            setAnalyticsDrawerRow(row);
        },
        closeAnalyticsDrawer: () => setAnalyticsDrawerRow(null),
        isAnalyticsDrawerOpen: !!analyticsDrawerRow,
    };
}
